export default __webpack_public_path__ + "static/media/an6.0d1d8d8b.jpg";